<template>
  <div id="app" v-cloak>
    <Login v-if="!user" @login="check()"></Login>
    <div v-if="user">
      <nav class="navbar navbar-expand navbar-light d-print-none mb-4">
        <router-link to="/" class="navbar-brand">
          <img
            class="d-none d-sm-block"
            src="images/logo.png"
            height="30"
            alt
            loading="lazy"
          />
          <img class="d-sm-none" src="q-logo.png" height="30" alt loading="lazy" />
        </router-link>
        <button
          class="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarsExample02"
          aria-controls="navbarsExample02"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarsExample02">
          <ul class="navbar-nav mr-auto">
            <!-- <li class="nav-item">
              <router-link to="/bifold" class="nav-link">Bifold door form</router-link>
            </li>
            <li class="nav-item">
              <router-link to="/quotes" class="nav-link">Quotes</router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/materials" class="nav-link">Materials</router-link>
            </li>
            <!-- <li class="nav-item">
              <router-link to="/entities" class="nav-link">Contacts</router-link>
            </li> -->
            <li class="nav-item">
              <router-link to="/assemblies" class="nav-link">Assemblies</router-link>
            </li>

            <li class="nav-item">
              <router-link to="/admin" class="nav-link">Admin</router-link>
            </li>
          </ul>

          <ul class="navbar-nav">
            <li class="nav-item">
              <a class="nav-link" href="#" @click="logout()">Logout</a>
            </li>
          </ul>
        </div>
      </nav>
      <div id="view">
        <router-view v-cloak />
      </div>
    </div>
  </div>
</template>

<script>
import Login from "./views/Login";
import { getUser, logout } from "./lib/auth";

export default {
  components: {
    Login,
  },
  data() {
    return {
      user: null,
    };
  },
  mounted() {
    this.check();
  },
  methods: {
    check() {
      getUser().then((u) => (this.user = u));
    },
    logout() {
      this.user = null;
      logout();
    },
  },
};
</script>

<style lang="scss">

body {
  padding-bottom: 1em;
}

$body-bg: white;
$body-color: black;

$list-group-bg: white;

$primary: #177caf;
$secondary: #21619a;

// Less white space
$spacer: 0.2rem;

// Reduce font to scale ui down a little
$font-size-base: 0.95rem;

// This reduces the headers on mobile
$enable-responsive-font-sizes: true;

// Active tab background
// $nav-tabs-link-active-bg: #dee2e6;

// Squarer corners
$border-radius: 0.1rem;
$border-radius-lg: 0.1rem;
$border-radius-sm: 0.1rem;

// Input padding
$input-btn-padding-y: 0.175rem;
$input-btn-padding-x: 0.5rem;

// $navbar-dark-color: rgb(255, 255, 255, 0.9);

@import "../node_modules/bootstrap/scss/bootstrap.scss";

.navbar {
  border-bottom: 1px solid silver;
}

input[type="number"] {
  text-align: right;
}

h1.page-header {
  border-bottom: solid 1px silver;
  margin: 0.8em 0;
}

input.loading::after {
  content: "XXX";
  margin-left: -20px;
  z-index: 1000;
}

// HTML Template

div.html-template table td, div.html-template table th {
  border: none;
  padding: 0;
  margin-bottom: 0.5em;
}

div.html-template table td p, div.html-template table th p {
  margin-bottom: 0;
}

div.html-template h1 {
  font-size: 20px;
  font-weight: bold;
  margin-top: 0.5em;
}

div.html-template h2 {
  font-size: 18px;
  font-weight: bold;
  margin-top: 0.5em;
}

div.html-template h4 {
  font-size: 17px;
  font-weight: bold;
  margin-top: 0.5em;
}

div.html-template h4 {
  font-size: 16px;
  font-weight: bold;
  margin-top: 0.5em;
}

div.html-template h5 {
  font-size: 15px;
  font-weight: bold;
  margin-top: 0.5em;
}

div.html-template h6 {
  font-size: 14px;
  font-weight: bold;
  margin-top: 0.5em;
}

label {
  color: #495057;
}
</style>
